module.exports = __webpack_public_path__ + "img/tz3.c258f765.png";